module.exports = __webpack_public_path__ + "static/img/logo.a6e9620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1